import PromoCodePage from './PromoCodePage';
import promoCodePageReducer from './reducer';

export { promoCodePageReducer };

export default PromoCodePage;
